import type { RootState } from 'tradera/state/configure-store';

export const selectStartPageStatus = (state: RootState) =>
    state.views.startPage.status;

export const selectStartPageHeader = (state: RootState) =>
    state.views.startPage.status === 'HAS_DATA'
        ? state.views.startPage.config.header
        : {
              isCampaignMode: false,
              displayRecentSearches: false,
              displayTrendingSearches: false
          };

export const selectLastChance = (state: RootState) =>
    state.views.startPage.lastChance;
